/**
 * Central Management > 통합관리 > 통합 스크립트
 * 예약실행 >> 스케줄 설정 store

 * @since 2018-06-29
 * @author devp018
 *
 * @since 2018-09-18
 * @author devp017
 */
import {clientDate, getStepDate} from '~/utils/date'

export const state = () => ({
  apiUrlPath: {
    'sechdulSet': '/api/cm/integrate-script/sched'
  },
  rowSelectItems: null,
  maxRecord: 10,
  pageSize: 5,
  selScriptId: 0,
  scriptSchDataList: [],
  scriptSched: {},
  scheduleParam: {
    expireDateUseYn: 1, // 기간설정 사용 여부
    expireDateStart: '',
    expireDateStartDay: clientDate('YYYY-MM-DD'),
    expireDateStartHour: 9,
    expireDateStartMin: 0,
    expireDateEnd: '',
    expireDateEndDay: getStepDate(new Date(), 'YYYY-MM-DD', 1, 'year'),
    expireDateEndHour: 18,
    expireDateEndMin: 0,
    months: {
      Jan: 1,
      Feb: 1,
      Mar: 1,
      Apr: 1,
      May: 1,
      Jun: 1,
      Jul: 1,
      Aug: 1,
      Sep: 1,
      Oct: 1,
      Nov: 1,
      Dec: 1
    },
    everyModeYn: 1,
    everyTimesYn: 1,
    date: {
      date1: 0,
      date2: 0,
      date3: 0,
      date4: 0,
      date5: 0,
      date6: 0,
      date7: 0,
      date8: 0,
      date9: 0,
      date10: 0,
      date11: 0,
      date12: 0,
      date13: 0,
      date14: 0,
      date15: 0,
      date16: 0,
      date17: 0,
      date18: 0,
      date19: 0,
      date20: 0,
      date21: 0,
      date22: 0,
      date23: 0,
      date24: 0,
      date25: 0,
      date26: 0,
      date27: 0,
      date28: 0,
      date29: 0,
      date30: 0,
      date31: 0
    },
    week: {
      mon: 1,
      tue: 1,
      wed: 1,
      thu: 1,
      fri: 1,
      sat: 1,
      sun: 1
    },
    hours: {
      hour: 12,
      everyHours: 6
    },
    minutes: {
      minute: 1,
      everyMinute: 0
    }
  }
})
export const mutations = {
  clearDetailPopup (state) {
    state.scheduleParam.expireDateUseYn = 1 // 기간설정 사용 여부
    state.scheduleParam.expireDateStart = ''
    state.scheduleParam.expireDateStartDay = clientDate('YYYY-MM-DD')
    state.scheduleParam.expireDateStartHour = 9
    state.scheduleParam.expireDateStartMin = 0
    state.scheduleParam.expireDateEnd = ''
    state.scheduleParam.expireDateEndDay = getStepDate(new Date(), 'YYYY-MM-DD', 1, 'year')
    state.scheduleParam.expireDateEndHour = 18
    state.scheduleParam.expireDateEndMin = 0
    state.scheduleParam.months.Jan = 1
    state.scheduleParam.months.Feb = 1
    state.scheduleParam.months.Mar = 1
    state.scheduleParam.months.Apr = 1
    state.scheduleParam.months.May = 1
    state.scheduleParam.months.Jun = 1
    state.scheduleParam.months.Jul = 1
    state.scheduleParam.months.Aug = 1
    state.scheduleParam.months.Sep = 1
    state.scheduleParam.months.Oct = 1
    state.scheduleParam.months.Nov = 1
    state.scheduleParam.months.Dec = 1
    state.scheduleParam.everyModeYn = 1
    state.scheduleParam.everyTimesYn = 1
    state.scheduleParam.date.date1 = 0
    state.scheduleParam.date.date2 = 0
    state.scheduleParam.date.date3 = 0
    state.scheduleParam.date.date4 = 0
    state.scheduleParam.date.date5 = 0
    state.scheduleParam.date.date6 = 0
    state.scheduleParam.date.date7 = 0
    state.scheduleParam.date.date8 = 0
    state.scheduleParam.date.date9 = 0
    state.scheduleParam.date.date10 = 0
    state.scheduleParam.date.date11 = 0
    state.scheduleParam.date.date12 = 0
    state.scheduleParam.date.date13 = 0
    state.scheduleParam.date.date14 = 0
    state.scheduleParam.date.date15 = 0
    state.scheduleParam.date.date16 = 0
    state.scheduleParam.date.date17 = 0
    state.scheduleParam.date.date18 = 0
    state.scheduleParam.date.date19 = 0
    state.scheduleParam.date.date20 = 0
    state.scheduleParam.date.date21 = 0
    state.scheduleParam.date.date22 = 0
    state.scheduleParam.date.date23 = 0
    state.scheduleParam.date.date24 = 0
    state.scheduleParam.date.date25 = 0
    state.scheduleParam.date.date26 = 0
    state.scheduleParam.date.date27 = 0
    state.scheduleParam.date.date28 = 0
    state.scheduleParam.date.date29 = 0
    state.scheduleParam.date.date30 = 0
    state.scheduleParam.date.date31 = 0
    state.scheduleParam.week.mon = 1
    state.scheduleParam.week.tue = 1
    state.scheduleParam.week.wed = 1
    state.scheduleParam.week.thu = 1
    state.scheduleParam.week.fri = 1
    state.scheduleParam.week.sat = 1
    state.scheduleParam.week.sun = 1
    state.scheduleParam.hours.hour = 12
    state.scheduleParam.hours.everyHours = 6
    state.scheduleParam.minutes.minute = 1
    // state.scheduleParam.minutes.everyMinute = 30
    state.scheduleParam.minutes.everyMinute = 0
  },
  mutSetScheduleList (state) {
    state.scriptSched = {}
  },
  mutGetScheduleListAll (state, { res, scriptId }) {
    if (res.length < 1) {
      state.scriptSchDataList = []
    } else {
      state.scriptSchDataList = Object.freeze(res)
    }
    state.selScriptId = scriptId
    state.maxRecord = Object.freeze(state.scriptSchDataList.length)
  },
  mutGetScheduleList (state, { res }) {
    if (res.length < 1) {
      state.scriptSched = []
    } else {
      state.scriptSched = res
    }
  },
  // 활성 전체 사용/사용 안 함 적용.
  changeAllActiveYn (state, data) {
    const activeData = _.cloneDeep(state.scriptSchDataList)
    _.forEach(activeData, o => {
      o.script_sched_use_yn = data
    })
    state.scriptSchDataList = activeData
  }
}

export const actions = {
  async getScheduleListAxiosAll ({commit, state}, payload) {
    const tmpx = JSON.parse(payload)
    try {
      const data = await this.$axios.$get(`${state.apiUrlPath.sechdulSet}/${tmpx.script_id}/0`)
      if (data.code.toUpperCase() !== 'OK') {
        this.$router.app.$alertPopUp.show(data.result.msg)
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutGetScheduleListAll', { res: data.result, scriptId: tmpx.script_id })
      return {code: 'ok'}
    } catch (error) {
      this.$router.app.$alertPopUp.show(error)
      return {code: 'error', errors: error}
    }
  },
  async getScheduleListAxios ({commit, state}, payload) {
    try {
      const data = await this.$axios.$get(`${state.apiUrlPath.sechdulSet}/${payload.script_id}/${payload.script_sched_id}`)
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutGetScheduleList', { res: data.result })
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async acsEditUseScriptSchedAxios ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(`${state.apiUrlPath.sechdulSet}/multi`, payload, {successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async acsAddScriptSchedAxios ({commit, state, dispatch}, { formData = {}, secure = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.apiUrlPath.sechdulSet}`, formData, {
        successAlert: false,
        secure
      })
      if (res.code === 'ok') {
        dispatch('getScheduleListAxiosAll', formData)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async acsEditScriptSchedAxios ({ commit, state, dispatch }, { formData = {}, secure = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrlPath.sechdulSet}`, formData, {
        successAlert: false,
        secure
      })
      if (res.code === 'ok') {
        dispatch('getScheduleListAxiosAll', formData)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async acsDelScriptSchedAxios ({commit, state, dispatch}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const tmpx = JSON.parse(payload)
      res = await this.$axios.$delete(`${state.apiUrlPath.sechdulSet}/${tmpx.script_sched_id}`, {
        data: tmpx
      }, {successAlert: false})
      if (res.code === 'ok') {
        dispatch('getScheduleListAxiosAll', payload)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {}

export const strict = false
